<div class="titleBox"> <h1 style="text-align: center">Cities</h1></div>
<div><hr></div>
<br>
<br>
<button class="buttonAddNew"  mat-raised-button (click)="addDialog()"> Add New City</button>
      <ngx-table [configuration] = "configuration"  [data]="gridEntrie$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate">
          <ng-template let-row>

          <td>
              <div>
                <button button mat-raised-button color="green" (click)="openDialog(row)">
                  <fa-icon [icon]="faedit"></fa-icon>
                </button>
              </div>

              <div>
                <button mat-button color="warn" (click)="delete(row)">
                  <fa-icon [icon]="fatrash"></fa-icon>
                </button>
              </div>
          </td>

            <td>
              <div>
                {{row.city}}
              </div>
            </td>

            <td>
                <div>
                  {{row.state}}
                </div>
            </td>

            <td>
              <div>
                {{row.region}}
              </div>
            </td>

            <td>
              <div>
                {{row.elevation}}
              </div>
            </td>

            <td>
              <div>

              </div>
          </td>



          </ng-template>
        </ngx-table>



<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>

